
















import { Component, Vue } from "vue-property-decorator";

@Component
export default class VesselComparisonEmptyState extends Vue {
  circleStyle(index: number) {
    const diameter = 45 + 52 * index;
    return {
      width: `${diameter}px`,
      height: `${diameter}px`,
      opacity: 1 - 0.14 * (index - 1),
    }
  }
}
